import React from "react"
import { Checkbox, Flex, Text } from "@chakra-ui/react"

type Props = {
  selectedStatusFilters: string[]
  onSelectStatusFilters: (filters) => void
}

const StatusFilter = ({ selectedStatusFilters, onSelectStatusFilters }: Props) => {
  const options = [
    { title: "Assigned Registration/Ticket", value: "true" },
    { title: "Unassigned Registration/Ticket", value: "false" },
  ]

  const handleFilterChange = (value: string) => {
    if (selectedStatusFilters.includes(value)) {
      onSelectStatusFilters(selectedStatusFilters.filter((filter) => filter !== value))
    } else {
      onSelectStatusFilters([...selectedStatusFilters, value])
    }
  }

  return (
    <>
      <Flex
        position="sticky"
        top={0}
        zIndex={1}
        h={12}
        justifyContent="center"
        alignItems="center"
        backgroundColor="gray.100"
        borderBottomWidth={1}
      >
        <Text fontWeight="semibold">Filter by Status</Text>
      </Flex>
      {options.map(({ title, value }) => (
        <Flex
          key={value}
          h={12}
          justifyContent="center"
          alignItems="center"
          borderBottomWidth={1}
          pl={4}
        >
          <Checkbox
            w="100%"
            height="100%"
            isChecked={selectedStatusFilters.includes(value)}
            onChange={() => handleFilterChange(value)}
          >
            {title}
          </Checkbox>
        </Flex>
      ))}
    </>
  )
}

export default StatusFilter
